interface ConfirmDialogProps {
  message: string;
  onCancel: () => void;
  onOk: () => void;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  message,
  onCancel,
  onOk,
}) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-75">
      <div className="bg-white w-3/4">
        <div className="block">
          <h2 className="flex items-center justify-center mt-12 mx-4">
            {message}
          </h2>
          <div className="mt-12">
            <button
              onClick={onCancel}
              className="inline-block border-t border-r border-black text-main-red w-1/2 py-3"
            >
              Cancel
            </button>
            <button
              className="inline-block border-t border-black text-sub-blue w-1/2 py-3"
              onClick={onOk}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
